import { get } from '@/api/fetch';
import { mapAuth0User } from '@/helpers/authUtils';
import { useAgencyStore } from '@/stores/agency/useAgencyStore';
import { useUserStore } from '@/stores/user/useUserStore';

export async function setMockUser(): Promise<void> {
  if (import.meta.env.VUE_APP_MOCK_AUTH === 'ui-tests') {
    const userStore = useUserStore();
    const agencyStore = useAgencyStore();
    const response = await get('/api/mockUser');
    const userJson = await response.json();
    const authenticatedUser = mapAuth0User(userJson);
    if (!authenticatedUser) return;
    await userStore.setUserData(authenticatedUser);
    await userStore.setUserDetails(authenticatedUser.auth0Id);
    await agencyStore.fetchAgencies();
    await agencyStore.switchToAgency();
  }
}
